export const getTabs = (can: any) => [
  {
    id: "1",
    type: "menu",
    name: "Главная",
    url: "/",
  },
  {
    id: "2",
    type: "menu",
    name: "Справочники",
    visible: can("view", "Menu.Catalogues"),
    items: [
      {
        id: "2_1",
        type: "submenu",
        name: "Рулоны",
        visible: can("view", "Menu.Catalogues.CargoRoll"),
        url: "/cargoRoll",
      },
      {
        id: "2_2",
        type: "submenu",
        name: "Паллеты",
        visible: can("view", "Menu.Catalogues.CargoPallet"),
        url: "/cargoPallet",
      },
      {
        id: "2_3",
        type: "submenu",
        name: "Грузовые вагоны",
        visible: can("view", "Menu.Catalogues.TransportBoxCar"),
        url: "/transportBoxCar",
      },
      {
        id: "2_4",
        type: "submenu",
        name: "Автотранспорт",
        visible: can("view", "Menu.Catalogues.TransportMotor"),
        url: "/transportMotor",
      },
      {
        id: "2_5",
        type: "submenu",
        name: "Контейнеры",
        visible: can("view", "Menu.Catalogues.TransportContainer"),
        url: "/transportContainer",
      },
      {
        id: "2_6",
        type: "submenu",
        name: "Смещения",
        visible: can("view", "Menu.Catalogues.Displacement"),
        url: "/displacement",
      },
      {
        id: "2_7",
        type: "submenu",
        name: "Отступы",
        visible: can("view", "Menu.Catalogues.Gap"),
        url: "/gap",
      },
      {
        id: "2_8",
        type: "submenu",
        name: "Реквизиты",
        visible: can("view", "Menu.Catalogues.Requisite"),
        url: "/requisite",
      },
    ],
  },
  {
    id: "3",
    type: "menu",
    name: "Журналы",
    visible: can("view", "Menu.Journals"),
    items: [
      {
        id: "3_1",
        type: "submenu",
        name: "Планы",
        visible: can("view", "Menu.Journals.Plan"),
        url: "/plans",
      },
    ],
  },
  {
    id: "4",
    type: "menu",
    name: "Отчеты",
    visible: can("view", "Menu.Reports"),
    items: [
      {
        id: "4_1",
        type: "submenu",
        name: "Отчет о погрузке",
        visible: can("view", "Menu.Reports.Loading"),
        url: "/loadingReport",
      },
      {
        id: "4_2",
        type: "submenu",
        name: "Отчет о погрузке РЖД",
        visible: can("view", "Menu.Reports.LoadingRzd"),
        url: "/loadingRZDReport",
      },
    ],
  },
  {
    id: "5",
    type: "menu",
    name: "Администрирование",
    visible: can("view", "Menu.System"),
    items: [
      {
        id: "5_1",
        type: "submenu",
        name: "Пользователи",
        visible: can("view", "Menu.System.User"),
        url: "/users",
      },
      {
        id: "5_2",
        type: "submenu",
        name: "Компании",
        visible: can("view", "Menu.System.Company"),
        url: "/company",
      },
      {
        id: "5_3",
        type: "submenu",
        name: "Роли",
        visible: can("view", "Menu.System.Role"),
        url: "/roles",
      },
      {
        id: "5_4",
        type: "submenu",
        name: "Импорт данных",
        visible: can("view", "Menu.System.Import"),
        url: "/import",
      },
      {
        id: "5_5",
        type: "submenu",
        name: "Менеджер по управлению планами",
        visible: can("view", "Menu.System.ManagerPlan"),
        url: "/planManager",
      },
      {
        id: "5_6",
        type: "submenu",
        name: "Действия пользователей",
        visible: can("view", "Menu.System.Logging"),
        url: "/logging",
      },
      {
        id: "5_7",
        type: "submenu",
        name: "Очистка данных",
        visible: can("view", "Menu.System.Cleanup"),
        url: "/cleanup",
      },
    ],
  },
  {
    id: "6",
    type: "menu",
    name: "Настройки",
    visible: can("view", "Menu.Settings"),
    url: "/settings",
  },
];

export const showFirstSubmenuModes = {
  name: "onHover",
  delay: { show: 0, hide: 100 },
};
